import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ImmomioIconName, SortingMenuBaseComponent } from '@resident-nx/shared';
import { IconWebComponent } from '@resident-nx/web/ui';

@Component({
  standalone: true,
  selector: 'rs-web-sorting-menu',
  imports: [IconWebComponent, NgbDropdownModule, TranslateModule, AsyncPipe],
  templateUrl: './sorting-menu.component.html',
  styleUrl: './sorting-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortingMenuComponent extends SortingMenuBaseComponent implements OnInit {
  public ImmomioIconName = ImmomioIconName;
}
